'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Form, Card } from 'react-bootstrap';
const uuid = require('uuid');

const _ = {
    find: require('lodash/find'),
};

const Globals = require('../../../../app/globals');

const RSDActions = require('../../actions/RSDActions');
const RSDStore = require('../../stores/RSDStore');

const propTypes = {
    serviceData: PropTypes.object,
    submitHandler: PropTypes.func.isRequired,
    closeHandler: PropTypes.func.isRequired,
    readOnly: PropTypes.bool,
};

const defaultProps = {
    show: true,
    readOnly: false
};

class OrgEditRSDServiceModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            serviceData: this.props.serviceData,
            test_rsd_id: '',
            test_name: '',
            test_description: '',
            test_error: ''
        };
        this.unsubscribes = [
            RSDStore.listen(this.onRSDStoreChange.bind(this)),
        ];
        
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    onRSDStoreChange(storeState) {
        const rsdStoreState = RSDStore.getState();
        if (storeState.action.id === this.state.test_action_id) {
            let lookup_id = this.state.test_rsd_id;
            const rsd = _.find(rsdStoreState.external_rsds,{rsd_id:this.state.test_rsd_id, rsd_service_id: this.props.serviceData.id});
            this.setState({
                test_action_id: null,
                lookup_id,
                test_name: rsd && rsd.name,
                test_description: rsd && rsd.description,
                test_valid: rsd ? "OK": "ID Not Found",
            });
        }
    }

    submitHandler=(e)=>{
        this.props.submitHandler(this.state.serviceData);
    }
    
    doTestRSID=()=>{
        const rsdStoreState = RSDStore.getState();
        const rsd = _.find(rsdStoreState.external_rsds,{rsd_id:this.state.test_rsd_id, rsd_service_id: this.props.serviceData.id});
        if (rsd) {
            this.setState({
                lookup_id: this.state.test_rsd_id,
                test_action_id: null,
                test_name: rsd && rsd.name,
                test_description: rsd && rsd.description,
                test_valid: rsd ? "OK": "ID Not Found",
            });
            return;
        }
        
        const actionId = uuid.v4();
        this.setState({
            lookup_id: null,
            test_action_id: actionId,
            test_error: '',
            test_name: '',
            test_description: ''
        },()=>{
            RSDActions.getNameAndDescription(actionId,{
                rsd_service_id: this.props.serviceData.id,
                rsd_id: this.state.test_rsd_id
            });
        });
    }
    
    render() {
        const serviceData = this.props.serviceData;
        return (
            <Modal
                show={this.props.show}
                size="lg"
                enforceFocus={false}
                autoFocus
                backdrop={false}
                animation={false}
                keyboard
                onHide={this.props.closeHandler}
            >
                <Modal.Header closeButton onHide={this.props.closeHandler}>
                    <Modal.Title>
                        {this.props.readOnly ?
                            "View RSD Service Details"
                            :
                            "Edit RSD Service Details"
                        }
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Form>
                        <Form.Group controlId="modal-edit-rsd-service-endpoint">
                            <Form.Row>
                                <Form.Label>{'Name'}</Form.Label>
                                <Form.Control
                                    as={'input'}
                                    disabled={this.props.readOnly}
                                    aria-label={'Name'}
                                    value={this.state.serviceData.name || ''}
                                    onChange={(e)=>{
                                        this.setState({ 
                                            serviceData: {
                                                ...this.state.serviceData,
                                                name:  e.target.value
                                            }
                                        })
                                    }}
                                />
                            </Form.Row>
                            { (this.state.serviceData.service_type === Globals.RSD_SERVICE_TYPES.OpenRSD) ?
                            [
                            <Form.Row key="rsd_id_prefix">
                                <Form.Label>{'RSD ID prefix'}</Form.Label>
                                <Form.Control
                                    as={'input'}
                                    disabled={this.props.readOnly}
                                    aria-label={'RSD ID prefix'}
                                    value={this.state.serviceData.details.rsd_id_prefix || ''}
                                    onChange={(e)=>{
                                        this.setState({ 
                                            serviceData: {
                                                ...this.state.serviceData,
                                                details: {
                                                    ...this.state.serviceData.details,
                                                    rsd_id_prefix: e.target.value 
                                                }
                                            }
                                        })
                                    }}
                                />
                            </Form.Row>,

                            <Form.Row key="rsd_id_suffix">
                                <Form.Label>{'RSD ID suffix'}</Form.Label>
                                <Form.Control
                                    as={'input'}
                                    disabled={this.props.readOnly}
                                    aria-label={'RSD ID suffix'}
                                    value={this.state.serviceData.details.rsd_id_suffix || ''}
                                    onChange={(e)=>{
                                        this.setState({ 
                                            serviceData: {
                                                ...this.state.serviceData,
                                                details: {
                                                    ...this.state.serviceData.details,
                                                    rsd_id_suffix: e.target.value 
                                                }
                                            }
                                        })
                                    }}
                                />
                            </Form.Row>,

                            <Form.Row key="base">
                                <Form.Label>{'Base API'}</Form.Label>
                                <Form.Control
                                    as={'input'}
                                    disabled={this.props.readOnly}
                                    aria-label={'Base Service API'}
                                    value={this.state.serviceData.details.base_api || ''}
                                    onChange={(e)=>{
                                        this.setState({ 
                                            serviceData: {
                                                ...this.state.serviceData,
                                                details: {
                                                    ...this.state.serviceData.details,
                                                    base_api: e.target.value 
                                                }
                                            }
                                        })
                                    }}
                                />
                            </Form.Row>,
                            <Form.Row key="api_suffix">
                                <Form.Label>{'API Suffix'}</Form.Label>
                                <Form.Control
                                    as={'input'}
                                    disabled={this.props.readOnly}
                                    aria-label={'API Suffix'}
                                    value={this.state.serviceData.details.api_suffix || ''}
                                    onChange={(e)=>{
                                        this.setState({ 
                                            serviceData: {
                                                ...this.state.serviceData,
                                                details: {
                                                    ...this.state.serviceData.details,
                                                    api_suffix: e.target.value 
                                                }
                                            }
                                        })
                                    }}
                                />
                            </Form.Row>
                            ] : null }
                        </Form.Group>
                        {!this.props.readOnly &&
                            <Button onClick={this.submitHandler}>
                                update
                            </Button>
                        }
                    </Form>
                    { (this.state.serviceData.service_type === Globals.RSD_SERVICE_TYPES.OpenRSD) ?
                    <Card body className="rsd-test-section">
                        <Card.Title>Test service skill id lookup</Card.Title>
                        <Form>
                            <Form.Group controlId="modal-edit-rsd-service-test">
                                <Form.Label>{'RSD ID'}</Form.Label>
                                <Form.Control
                                    as={'input'}
                                    aria-label={'RSD ID'}
                                    disabled={this.state.test_action_id}
                                    value={this.state.test_rsd_id}
                                    onChange={(e)=>{
                                        this.setState({
                                            test_rsd_id: e.target.value,
                                            test_name: '',
                                            test_description: '',
                                            test_valid: '',
                                            lookup_id: null,
                                        });
                                    }}
                                />
                            </Form.Group>
                            {this.state.lookup_id ? 
                            [
                                <Form.Row key="name">
                                    <label>{'Name:'}</label>
                                    <span>{this.state.test_name}</span>
                                </Form.Row>,
                                <Form.Row key="description">
                                    <label>{'Description:'}</label>
                                    <span>{this.state.test_description}</span>
                                </Form.Row>,
                                <Form.Row key="found">
                                    <label>{'Result:'}</label>
                                    <span>{this.state.test_valid}</span>
                                </Form.Row>,
                            ] : null }
                                <Button onClick={this.doTestRSID}>
                                    look up
                                </Button>
                        </Form>
                    </Card>
                    : null }
                </Modal.Body>

                <Modal.Footer>
                    <Button onClick={this.props.closeHandler}>
                        close
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

OrgEditRSDServiceModal.propTypes = propTypes;
OrgEditRSDServiceModal.defaultProps = defaultProps;

export default OrgEditRSDServiceModal;